(() => {
  if (window.__pelykoHeaderUpgradeLoaded) return;
  window.__pelykoHeaderUpgradeLoaded = true;

  const navs = [...document.querySelectorAll('.pelyko-shell .pelyko-nav')];
  if (!navs.length) return;

  const icon = {
    search: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="6.5"></circle><path d="m16 16 4.3 4.3"></path></svg>',
    account: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="3.5"></circle><path d="M5.5 20c.7-4 3-6 6.5-6s5.8 2 6.5 6"></path></svg>',
    tracking: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7.5 12 3l8 4.5v9L12 21l-8-4.5z"></path><path d="m4 7.5 8 4.5 8-4.5M12 12v9"></path></svg>',
    cart: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4h2l2.2 10.3a2 2 0 0 0 2 1.6h7.8a2 2 0 0 0 1.9-1.4L21 8H6"></path><path d="M9 8v5M13 8v5M17 8v5M7.5 11h11"></path><circle cx="9.5" cy="19" r="1.2"></circle><circle cx="17" cy="19" r="1.2"></circle></svg>'
  };

  const style = document.createElement('style');
  style.id = 'pelyko-header-upgrade-style';
  style.textContent = `
    .pelyko-top-ticker{position:relative;z-index:45;background:#183b32;color:#fff;overflow:hidden;border-bottom:1px solid rgba(255,255,255,.12)}
    .pelyko-top-ticker__viewport{overflow:hidden}
    .pelyko-top-ticker__track{display:flex;width:max-content;align-items:center;animation:pelykoTopTicker 34s linear infinite;will-change:transform}
    .pelyko-top-ticker__item{display:flex;align-items:center;gap:10px;padding:8px 30px;white-space:nowrap;font-size:11px;font-weight:750;letter-spacing:.055em}
    .pelyko-top-ticker__dot{width:4px;height:4px;border-radius:50%;background:currentColor;opacity:.65;flex:0 0 auto}
    @keyframes pelykoTopTicker{to{transform:translateX(-50%)}}
    .pelyko-nav__actions{justify-self:end;display:flex;align-items:center;gap:3px;min-width:0}
    .pelyko-icon-link{position:relative;width:42px;height:42px;border-radius:999px;display:grid;place-items:center;color:var(--pk-sage-dark,#4f6654);text-decoration:none;transition:background .18s ease,transform .18s ease,color .18s ease}
    .pelyko-icon-link svg{width:22px;height:22px;fill:none;stroke:currentColor;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round}
    .pelyko-icon-link:hover{background:rgba(79,102,84,.09);transform:translateY(-1px);color:#183b32}
    .pelyko-icon-link--tracking{width:auto;display:flex;padding:0 11px;gap:7px;font-size:11px;font-weight:760;white-space:nowrap}
    .pelyko-icon-link--tracking svg{width:20px;height:20px}
    .pelyko-icon-count{position:absolute;top:1px;right:0;min-width:17px;height:17px;padding:0 4px;border-radius:999px;display:grid;place-items:center;background:var(--pk-ink,#111512);color:#fff;font-size:9px;font-weight:800;line-height:1}
    .pelyko-icon-count:empty{display:none}
    @media(max-width:620px){
      .pelyko-icon-link{width:36px;height:36px}
      .pelyko-icon-link--tracking{width:36px;padding:0}
      .pelyko-icon-link--tracking span{display:none}
      .pelyko-icon-link svg{width:20px;height:20px}
      .pelyko-nav__actions{gap:0}
      .pelyko-top-ticker__item{padding:7px 22px;font-size:10px}
    }
    @media(prefers-reduced-motion:reduce){
      .pelyko-top-ticker__track{animation:none;width:auto;justify-content:center;flex-wrap:wrap}
      .pelyko-top-ticker__track [data-pelyko-ticker-copy]{display:none}
      .pelyko-icon-link{transition:none}
    }
  `;
  document.head.appendChild(style);

  const messages = [
    'Des gestes simples pour le quotidien avec chien & chat',
    'Suivi de commande disponible',
    'Paiement sécurisé',
    '14 jours pour exercer votre droit de rétractation',
    'Garantie légale de conformité · 2 ans'
  ];

  const ticker = document.createElement('div');
  ticker.className = 'pelyko-top-ticker';
  ticker.setAttribute('aria-label', 'Informations PELYKO');
  const viewport = document.createElement('div');
  viewport.className = 'pelyko-top-ticker__viewport';
  const track = document.createElement('div');
  track.className = 'pelyko-top-ticker__track';

  const addMessages = (copy) => {
    messages.forEach((message) => {
      const item = document.createElement('span');
      item.className = 'pelyko-top-ticker__item';
      if (copy) {
        item.setAttribute('aria-hidden', 'true');
        item.dataset.pelykoTickerCopy = 'true';
      }
      const dot = document.createElement('i');
      dot.className = 'pelyko-top-ticker__dot';
      dot.setAttribute('aria-hidden', 'true');
      const text = document.createElement('span');
      text.textContent = message;
      item.append(dot, text);
      track.appendChild(item);
    });
  };
  addMessages(false);
  addMessages(true);
  viewport.appendChild(track);
  ticker.appendChild(viewport);
  navs[0].parentNode.insertBefore(ticker, navs[0]);

  navs.forEach((nav) => {
    const inner = nav.querySelector('.pelyko-nav__inner');
    const oldCart = nav.querySelector('.pelyko-cart-link');
    if (!inner || !oldCart || inner.querySelector('.pelyko-nav__actions')) return;

    const oldCount = oldCart.querySelector('.pelyko-cart-link__count, [data-pelyko-cart-count]');
    const count = (oldCount?.textContent || '0').trim();

    const actions = document.createElement('div');
    actions.className = 'pelyko-nav__actions';
    actions.innerHTML = `
      <a class="pelyko-icon-link" href="/search" aria-label="Rechercher" title="Rechercher">${icon.search}</a>
      <a class="pelyko-icon-link" href="/account" aria-label="Mon compte" title="Mon compte">${icon.account}</a>
      <a class="pelyko-icon-link pelyko-icon-link--tracking" href="/pages/suivi-de-commande" aria-label="Suivi de commande" title="Suivi de commande">${icon.tracking}<span>Suivi</span></a>
      <a class="pelyko-icon-link pelyko-icon-link--cart" href="/cart" aria-label="Panier" title="Panier">${icon.cart}<span class="pelyko-icon-count" data-pelyko-cart-count>${count}</span></a>
    `;
    oldCart.replaceWith(actions);
  });

  const applyRequestedCleanup = () => {
    document.querySelectorAll('.pelyko-home > .pelyko-announcement, .pelyko-pdp > .pelyko-announcement, .pelyko-precheckout > .pelyko-checkout-topbar').forEach((el) => el.remove());

    const diffText = document.querySelector('.pelyko-diff-chip span');
    if (diffText && diffText.textContent.trim() === '4 produits. 4 gestes. Pas un catalogue infini.') {
      diffText.textContent = '4 produits. 4 gestes.';
    }

    document.querySelectorAll('.pelyko-trust-proofbar strong').forEach((el) => {
      if (el.textContent.trim() === 'Paiement Shopify') el.textContent = 'Paiement sécurisé';
    });

    document.querySelectorAll('.pelyko-offer-finale__points span').forEach((el) => {
      if (el.textContent.trim() === '✓ Paiement traité via Shopify') el.textContent = '✓ Paiement sécurisé';
    });

    const checkoutHead = document.querySelector('.pelyko-checkout-head p');
    if (checkoutHead && checkoutHead.textContent.includes('passez au paiement Shopify.')) {
      checkoutHead.textContent = checkoutHead.textContent.replace('passez au paiement Shopify.', 'passez au paiement.');
    }

    document.querySelectorAll('.pelyko-checkout-trustgrid small').forEach((el) => {
      if (el.textContent.trim() === 'Traité dans l’environnement Shopify') el.textContent = 'Transaction protégée';
    });

    const secureNote = document.querySelector('.pelyko-secure-note');
    if (secureNote && secureNote.textContent.trim() === 'Connexion chiffrée · Paiement traité par Shopify') {
      secureNote.textContent = 'Connexion chiffrée · Paiement sécurisé';
    }

    document.querySelectorAll('#avis .pelyko-social-strip span').forEach((el) => {
      if (el.textContent.trim() === 'traité dans Shopify') el.textContent = 'paiement protégé';
    });
  };

  applyRequestedCleanup();
  const cleanupObserver = new MutationObserver(applyRequestedCleanup);
  cleanupObserver.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(() => cleanupObserver.disconnect(), 2500);
})();

/* PELYKO — 15/09/2026 : les blocs « Trustpilot » et « +5 000 clients satisfaits »
   (barre du haut, section avis, page de paiement) ont été supprimés à la demande
   d'Olivier. PELYKO n'a pas de profil Trustpilot et n'a pas 5 000 clients :
   les afficher était une pratique commerciale trompeuse. Ne pas les remettre.
   Les avis clients de la section #avis ne sont pas concernés. */
